import { themeObject } from '../../lib';

export const emptyStateStyles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mt: 5,
    },
    image: {
        width: '90px',
        height: '82.34px',
    },
    title: {
        my: 2,
        ...themeObject.typography.h2,
        fontSize: '26px',
        lineHeight: '100%',
        color: themeObject.palette.primary[700],
    },
    subtitle: {
        mb: 2,
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body3,
        ...themeObject.typography.body.regular,
        lineHeight: '100%',
        color: themeObject.palette.grayScale[700],
    },
    createButton: {
        borderRadius: '64px',
        width: '180px',
        height: '35px',
        '& .MuiTypography-root': {
            fontFamily: 'Red Hat Text',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '24px',
            color: themeObject.palette.grayScale[700],
            ml: '2px',
        },
    },
};
